<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div *ngIf="!showSentForgotRequest">
      <div class="password-title">{{'PASSWORDDIALOG.TITLE' | translate}}</div>
      <div class="password-box">
        <input type="password" [(ngModel)]="enteredPassword" [placeholder]="'PASSWORDDIALOG.PASSWORD' | translate">
        <div class="forgot-box">
          <button class="w-link-btn" (click)="forgotPassword()">{{'PASSWORDDIALOG.FORGOT' | translate}}</button>
        </div>
      </div>
      <div class="confirm-btn">
        <button class="w-btn orange-btn" [disabled]="!enteredPassword || enteredPassword.length < 7"
                (click)="checkPassword(enteredPassword)">
          {{'CONFIRM' | translate}}
        </button>
        <button class="w-link-btn" (click)="dialogRef.close()">
          {{'CANCEL' | translate}}
        </button>
      </div>
    </div>
    <div class="forgot-box" *ngIf="showSentForgotRequest">
      <div class="forgot-text">{{'PASSWORDDIALOG.SENTTEXT' | translate}}</div>
      <button class="w-link-btn" (click)="dialogRef.close()">
        {{'CLOSE' | translate}}
      </button>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
